export default __webpack_public_path__ + "dd065c018eb9c86a96401ec8b117e4d3.png";